<template>
  <canvas :id="name"></canvas>   
</template>
<script>
import Chart from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import 'chart.piecelabel.js';
export default {
  name: 'Pie',
  props: [
    'name',
    'title',
    'labels',
    'backgroundColors',
    'options',
    'items',
    'width',
    'height'
  ],
  data() {
    return {
    };
  },
  mounted() {
    this.renderChart()
  },
  methods: {
    renderChart() {
      var ctx = document.getElementById(this.name);
      const config = {
        type: 'pie',
        data: {
          'labels': this.labels,
          'datasets': [
            {
              'data': this.items,
              'backgroundColor': this.backgroundColors
            }
          ]
        },
        options: this.options
      };
      // interpolate variables inside string as dynamic window object
      if (window[`pie_${this.name}`] !== undefined) {
        window[`pie_${this.name}`].destroy()
      }
      window[`pie_${this.name}`] = new Chart(ctx, config)
    }
  }
};
</script>



// WEBPACK FOOTER //
// Pie.vue?9273968e